import { render, staticRenderFns } from "./SupportTicketDialogReopen.vue?vue&type=template&id=d662ddda"
import script from "./SupportTicketDialogReopen.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogReopen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports